import Comment from '@src/components/Molecules/Comment/Comment';
import DetailContent from '@src/components/Organism/Card/DetailContent';
import useAuth from '@src/hooks/useAuth';
import { authKeys } from '@src/keys/authKey';
import { auth } from '@src/services/api';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
type Props = {
  community: any;
  isMine: boolean;
};
const DetailCardTemplate = ({ community, isMine }: Props) => {
  return (
    <>
      <DetailContent community={community} isMine={isMine} />
      <Comment replies={community?.replies} communityId={community?.uuid} />
    </>
  );
};

export default DetailCardTemplate;
